var map = {
	"./Logo_Inecol31": 62,
	"./Logo_Inecol31.jpg": 62,
	"./avatar": 63,
	"./avatar.png": 63,
	"./fondo": 64,
	"./fondo.jpg": 64,
	"./imgfondo": 65,
	"./imgfondo.jpg": 65,
	"./logo100_White": 66,
	"./logo100_White.png": 66,
	"./logo60": 67,
	"./logo60.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;